// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-link[data-v-096a77d6]{outline:2px solid transparent;outline-offset:2px;font-size:14px;font-weight:400}.app-link[data-v-096a77d6]:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
